import * as fromRoot from '../../reducers';
import { Component, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from '../../lib/services';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { delay, startWith, tap } from 'rxjs/operators';
import { Page } from '../../lib/classes/page';
import { PaymentStatusRequested } from '../../core/actions/paymentStatus';
import {
  LoadCurrentUnit,
  LoadUserEmployments,
} from '../../core/actions/employment';
import * as unitActions from '../../settings-module/actions/unit';

@Component({
  selector: 'mj-select-unit',
  templateUrl: './selectUnit.template.html',
  styleUrls: ['./selectUnit.style.scss'],
})
export class SelectUnitComponent {
  @ViewChild('unitList', { static: true }) unitList;

  public employments$: Observable<any[]>;
  loading: boolean;
  employmentsPagination$;
  loadedAll: boolean;

  constructor(
    private _requestService: RequestService,
    private _router: Router,
    private store: Store<fromRoot.State>
  ) {
    this.employments$ = this.store.select(fromRoot.getUserEmployments).pipe(
      startWith(null),
      delay(0),
      tap(() => (this.loading = false))
    );

    this.employmentsPagination$ = this.store
      .select(fromRoot.getUserEmploymentsPagination)
      .subscribe((pagination: Page<Array<any>>) => {
        if (pagination) {
          this.loadedAll = !pagination.next;
        }
      });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(e) {
    const scrolled = e.target.scrollingElement.scrollTop + window.innerHeight;
    const scrollContainerHeight = e.target.scrollingElement.scrollHeight;

    if (
      scrollContainerHeight - 400 <= scrolled &&
      !this.loading &&
      !this.loadedAll
    ) {
      this.loading = true;
      this.store.dispatch(new LoadUserEmployments());
    }
  }

  public setSelectedUnit(unit) {
    localStorage.setItem('unit_id', unit.id);
    localStorage.setItem('unit_name', unit.name);

    this.store.dispatch(new PaymentStatusRequested(unit.id));
    this.store.dispatch(new LoadCurrentUnit({ selectedUnitId: unit.id }));

    this._requestService.invalidate('unit');
    this._requestService.invalidate('assignedJobs');
    this._router.navigate(['dashboard', 'overview']);
  }
}
